import * as React from 'react';
import antd, { Row, Col, Divider } from 'antd';
import HomeDescription from './HomeDescription';
import Search from 'antd/lib/input/Search';
import ArrivalSchedule from '../../components/Schedule/ArrivalSchedule/ArrivalSchedule';
// import StrippingSchedule from '../../components/Schedule/StrippingSchedule'
import StrippingScheduleForm from '../../components/Schedule/StrippingSchedule';
import { NavLink } from 'react-router-dom';
import CardRegistrationNotificationView from 'components/Payment/CardRegistrationNotificationView';
import { Helmet } from 'react-helmet';
import HomeRightSection from './HomeRightSection/HomeRightSection';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  homeMode: boolean;
}

export default class HomePage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      homeMode: true,
    };
  }

  componentDidMount() {
    this.setState({ homeMode: true });
  }

  render() {
    return (
      <>
        <div>
          <Helmet>
            <title>Home</title>
          </Helmet>
          <Row type="flex" style={{ textAlign: 'left', marginTop: '35px', textAlignLast: "center" }}>
            <Col span={24}>
              <h2>Welcome to the Kingston Wharves eServices Portal</h2>
            </Col>
            <HomeDescription />
            <Col style={{ border: '2px lightgrey solid' }} />
            <HomeRightSection />
          </Row>
          <CardRegistrationNotificationView />
        </div>
      </>
    );
  }
}

const rowStyle = {
  margin: '30px 30px 5px 30px',
};

const borderedRowStype = {
  borderRight: '3px gray solid',
};

////bill lading seach component - USE CONDITIONAL RENDERING TO SHOW LIST THIS WHEN LOGGED IN OR LOGGED OUT & TO SHOW SEARCH OR
////THE LIST OF BILL OF LADING.
export function BillLadingSeach() {
  const { Button, Row, Col } = antd;
  return (
    <div>
      <Row>
        <Col>
          <Search placeholder="Search by Bill Lading" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button style={{ float: 'right', marginTop: '5px' }}>Search</Button>
        </Col>
      </Row>
    </div>
  );
}
